module.exports = {
    //apiDomain: "https://h63.cnnd.vn/Widget",
    // apiDomain: "https://minisiteapi.dev.cnnd.vn/Widget",
     apiDomain: "https://minisiteapicnnd.dev.cnnd.vn/Widget"

}